<template>
  <b-overlay :show="removeItemState.loading && removeItemState.itemId === petId" rounded="sm" variant="white">
    <div class="wallet-card-product product pr-1">
      <b-row no-gutters align-v="center">
        <b-col cols="auto" class="pl-2">
          <b-img :src="require('@/assets/images/wallets/paw_card.png')" class="d-none d-md-block" width="90px" height="90px" alt="" />
          <b-img :src="require('@/assets/images/wallets/paw_card.png')" class="d-block d-md-none" width="60px" height="60px" alt="" />
        </b-col>
        <b-col class="ml-2">
          <h4 class="m-0 product-name mb-1">
            {{ $t('basket.walletCard.petIdentification') }}
          </h4>
          <template v-if="!walletCardComplete">
            <h5 class="m-0 text-danger">{{ $t('basket.walletCard.missingInfo') }}</h5>
            <b-link @click="finishWalletCard()" v-if="petName">
              <h5 class="m-0 text-primary">
                <u>{{ $t('basket.walletCard.finishPet', { petName: petName }) }}</u>
              </h5>
            </b-link>
            <b-link @click="assignWalletCard()" v-else>
              <h5 class="m-0 text-primary">
                <u>{{ $t('basket.walletCard.assignPet') }}</u>
              </h5>
            </b-link>
          </template>
        </b-col>
        <b-col cols="auto" class="d-flex align-items-center mt-2 mt-xs-0">
          <b-button v-if="remove" variant="link" class="m-0 p-0 text-right" block @click="removeWalletCard(petId)">
            {{ $t('product.remove') }}
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div ref="confirmationModal"></div>
  </b-overlay>
</template>

<script>
import Vue from 'vue';
import { DpConfirmationModal } from '@docupet/component-library';

export default {
  name: 'ConfigureWalletCard',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    DpConfirmationModal,
  },
  props: {
    petId: {
      type: String,
      required: false,
    },
    petName: {
      type: String,
      required: false,
    },
    remove: {
      type: Boolean,
      required: false,
      default: false,
    },
    removeItemState: {
      type: Object,
      required: true,
      default: null,
    },
    walletCardComplete: {
      type: Boolean,
      required: false,
      default: true,
    },
    locale: {
      type: String,
      required: true,
      default: 'en_US',
    },
    orderId: {
      type: [String, Number],
      required: false,
      default: null,
    },
    order: {
      type: Object,
      required: false,
      default: null,
    },
    orderItemBundle: {
      type: Object,
      required: false,
      default: null,
    },
  },
  computed: {
    walletCardSelectionLink() {
      return this.$store.getters.generateFullUrl(
        `/${this.orderId ? `order/${this.orderId}/` : ''}store/wallet-cards/pet/${this.petId}/style/all?redirect_path=basket`
      );
    },
  },
  methods: {
    async removeWalletCard(petId, confirm = false) {
      if (this.orderItemBundle !== null) {
        if (confirm === false) {
          this.showRemoveBundleItemConfirmationModal();
          return;
        }
        this.$emit('remove-bundle');
      }
      await this.removeIncompleteWalletCardItems();
      await this.$store.dispatch('order/removeWalletCard', {
        orderId: this.orderId,
        petId: petId,
        optInForWalletCard: false,
        removeFromBasket: true,
      });
    },
    async finishWalletCard() {
      await this.removeIncompleteWalletCardItems();
      window.location.href = this.walletCardSelectionLink;
    },
    async assignWalletCard() {
      window.location.href = this.$store.getters.generateFullUrl(`/${this.orderId ? `order/${this.orderId}/` : ''}store`);
    },
    async removeIncompleteWalletCardItems() {
      // TODO: Remove this method once we have a better way to handle incomplete wallet card items in the backend
      const incompleteWalletCards = this.order?.items?.filter(
        (item) =>
          item?.group?.pet?.id === this.petId && item.product?.type === 'WALLET_CARD' && false === item.isCompleted && null === item.parent
      );
      await incompleteWalletCards?.map(
        async (item) =>
          await this.$store.dispatch('order/removeItem', {
            orderId: this.orderId,
            itemId: item.id,
          })
      );
    },
    showRemoveBundleItemConfirmationModal() {
      const modalContainer = this.$refs.confirmationModal;

      if (modalContainer.childNodes.length) {
        modalContainer.childNodes.forEach((node) => node.remove());
      }

      new Vue({
        render: (h) => {
          let messageText = this.$t('product.removeBundleItemConfirmation.messageNoPet')

          if (this.petName) {
            messageText = this.$t('sideBasket.removeBundleItemConfirmation.message', {
              petName: this.petName,
            })
          }

          return h(DpConfirmationModal, {
            props: {
              id: `remove-item-confirmation-${this.petId}`,
              title: this.$t('sideBasket.removeBundleItemConfirmation.title'),
              message: messageText,
              cancelButtonText: this.$t('sideBasket.removeBundleItemConfirmation.cancelButtonText'),
              confirmButtonText: this.$t('sideBasket.removeBundleItemConfirmation.confirmButtonText'),
              show: true,
            },
            on: {
              confirm: () => this.removeWalletCard(this.petId, true),
              cancel: () => modalContainer.childNodes.forEach((node) => node.remove()),
            },
          });
        },
      }).$mount(modalContainer);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/main';
$grid-breakpoints: (
  xs: 450px,
);
.product {
  h5 {
    font-size: 0.9rem;
  }
  @include media-breakpoint-up(xs) {
    h4 {
      font-size: $h3-font-size;
    }
    h5 {
      font-size: $h4-font-size;
    }
    .mt-xs-0 {
      margin-top: 0 !important;
    }
  }
  .product-name {
    color: $dp-gray-7;
  }
}
</style>
